import http from '@/utils/Http'

const searchState = () => {
    return {
        current_page: 1,
        per_page: 0,
        total_entries: 0,
        entries: []
    }
};

const BASE_PATH = '/v1/commission_payments';

const loadEntries = (path) => {
    return new Promise((resolve, reject) => {
        http.get(path)
            .then(({data}) => resolve(data))
            .catch(reject);
    })
};

export default {
    namespaced: true,
    state: {
        search: searchState(),
    },
    getters: {
        search(state) {
            return state.search;
        }
    },
    mutations: {
        resetSearch(state, defaultValues = {}) {
            state.search = Object.assign({}, searchState(), defaultValues);
        },
        setSearch(state, payload) {
            state.search = payload;
        }
    },
    actions: {
        async filter({commit, state}, path) {
            return new Promise((resolve, reject) => {
                loadEntries(path)
                    .then(data => {
                        commit('setSearch', Object.assign({}, state.search, data));
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadMore({}, path) {
            return loadEntries(path);
        },
        async resetSearch({commit}, defaultValues = {}) {
            commit('resetSearch', defaultValues);
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            return new Promise((resolve, reject) => {
                if(payload.id) {
                    http.put(`${BASE_PATH}/${payload.id}`, {financial_movement: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                } else {
                    http.post(BASE_PATH, {financial_movement: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                }
            })
        }
    }
}
